import { render, staticRenderFns } from "./GroupInviteDialog.vue?vue&type=template&id=0667ae5e&scoped=true"
import script from "./GroupInviteDialog.vue?vue&type=script&lang=js"
export * from "./GroupInviteDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupInviteDialog.vue?vue&type=style&index=0&id=0667ae5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0667ae5e",
  null
  
)

export default component.exports